import { ReactNode, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'

import { joinStyles, palette, various } from 'app/utils/theme'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: various.padding,
        color: palette.text.primary,
        borderRadius: various.borderRadius,
    },
})

type TabsProperties = {
    children: ReactNode
    className?: string
    groupName: string
}

export const Tabs = ({
    children,
    className,
    groupName,
}: Readonly<TabsProperties>): JSX.Element => {
    const classes = useStyles()

    const [mounted, setMounted] = useState(false)

    useEffect(() => setMounted(true), [])

    // Give group name to all chlidren tab
    useEffect(() => {
        const tabGroup = document.querySelector(`#${groupName}`)

        if (tabGroup) {
            for (const tab of tabGroup.querySelectorAll(':scope > input')) {
                tab.setAttribute('name', groupName)
            }
        }

        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [mounted])

    return (
        <div
            id={groupName}
            className={joinStyles(classes.root, className)}
        >
            {children}
        </div>
    )
}
